export default {
    loading: 0,
    error: false,
    message: null
};
